import { render, staticRenderFns } from "./FlowEditBoSetting.vue?vue&type=template&id=a08db3f6&scoped=true&"
import script from "./FlowEditBoSetting.vue?vue&type=script&lang=js&"
export * from "./FlowEditBoSetting.vue?vue&type=script&lang=js&"
import style0 from "./FlowEditBoSetting.vue?vue&type=style&index=0&id=a08db3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08db3f6",
  null
  
)

export default component.exports